

import '../style/GradientPlaceholder.css';

const EMOJI_MAP = [
  [['momo', 'dumpling', 'steam', 'fried', 'tandoori'], '🥟'],
  [['water', 'bisleri', 'kinley'], '💧'],
  [['cake', 'lava', 'brownie', 'choco'], '🎂'],
  [['dosa', 'dossa', 'idli', 'vada'], '🫓'],
  [['rice', 'biryani', 'pulao'], '🍚'],
  [['paneer', 'cheese'], '🧀'],
  [['pizza'], '🍕'],
  [['burger'], '🍔'],
  [['noodle', 'pasta', 'hakka'], '🍜'],
];

const GRADIENTS = [
  ['#ffecd2', '#fcb69f'], ['#a1c4fd', '#c2e9fb'],
  ['#d4fc79', '#96e6a1'], ['#fbc2eb', '#a6c1ee'],
  ['#ffeaa7', '#fdcb6e'], ['#fd79a8', '#e84393'],
  ['#55efc4', '#00b894'], ['#74b9ff', '#0984e3'],
  ['#a29bfe', '#6c5ce7'], ['#fab1a0', '#e17055'],
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function GradientPlaceholder({ name, className = '' }) {
  const [c1, c2] = GRADIENTS[hash(name) % GRADIENTS.length];
  const emoji = EMOJI_MAP.find(([keys]) =>
    keys.some(k => name.toLowerCase().includes(k))
  )?.[1] ?? '🍽️';

  return (
    <div
      className={`to-dish-placeholder ${className}`}
      style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}
    >
      <span className="to-ph-emoji">{emoji}</span>
    </div>
  );
}